import { CompareButton } from '../components/atomic/compare-button.vue';
Vue.component('compare-button', CompareButton);